import type { FileRecord } from '../schemas';

/** Does this file contribute rows to a figure? */
export function isIncluded(file: FileRecord): boolean {
	return file.status === 'READY';
}

/** Is a person's decision the only thing between this file and use? */
export function needsMapping(file: FileRecord): boolean {
	return file.status === 'MAPPING_REQUIRED';
}

/** Is pressing "Process now" the only thing between this file and use? */
export function needsProcessing(file: FileRecord): boolean {
	/* An H2R file is never classified: normalising is all the processing it has. */
	if (file.module === 'H2R') return false;
	/* MAPPING_CONFIRMED counts too: it is where a file lands when normalising
     never finished, and those files are stuck unless they are offered here. */
	return file.status === 'NORMALISED' || file.status === 'MAPPING_CONFIRMED';
}

/** H2R: a confirmed mapping whose processing never finished. There is no rules
 *  review to offer, so the way forward is to process the mapping again. */
export function needsProcessAgain(file: FileRecord): boolean {
	return file.module === 'H2R' && file.status === 'MAPPING_CONFIRMED';
}

/** The extension of the uploaded file, upper-cased. The schema has no format
 *  column, so the type shown to a reader is derived from the name. */
export function fileFormat(file: FileRecord): string {
	const extension = /\.([a-zA-Z0-9]+)$/.exec(file.originalName)?.[1];
	return extension ? extension.toUpperCase() : 'FILE';
}
